import React from 'react';
import { Wind, Eye, Scan, Anchor, Heart, Shield, Brain, Sparkles } from 'lucide-react';
const STEPS = [{
  icon: Wind,
  title: 'Respiración vagal 1:2',
  desc: 'Exhalación más larga que inhalación'
}, {
  icon: Eye,
  title: 'Reflejo visual calmante',
  desc: 'Saca al cerebro del modo amenaza'
}, {
  icon: Scan,
  title: 'Liberación de tensión',
  desc: 'Escaneo corporal guiado'
}, {
  icon: Anchor,
  title: 'Anclaje de seguridad',
  desc: 'Señal somática de calma interna'
}];
export function SolutionSection() {
  return <section className="py-20 bg-[#FDF8F4] px-4" data-id="element-274">
      <div className="max-w-5xl mx-auto" data-id="element-275">
        {/* How it works */}
        <div className="text-center mb-12" data-id="element-276">
          <span className="text-[#C06B6B] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-277">
            Cómo funciona
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-278">
            Calma-5™ en 5 minutos
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-279">
            Una secuencia de 4 pasos que activa tu nervio vago y le enseña a tu
            cuerpo que el peligro terminó.
          </p>
        </div>

        {/* Step cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-280">
          {STEPS.map((step, i) => <div key={i} className="bg-white rounded-2xl p-5 border border-[#C06B6B]/10 shadow-sm text-center" data-id="element-281">
              <div className="w-12 h-12 bg-[#C06B6B]/10 rounded-xl flex items-center justify-center mx-auto mb-3" data-id="element-282">
                <step.icon className="h-6 w-6 text-[#C06B6B]" data-id="element-283" />
              </div>
              <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-284">
                {step.title}
              </p>
              <p className="text-xs text-gray-500" data-id="element-285">{step.desc}</p>
            </div>)}
        </div>

        <p className="text-center text-[#C06B6B] font-medium mb-16" data-id="element-286">
          En 60–90 segundos tu cuerpo empieza a activar la rama parasimpática.
        </p>

        {/* Results */}
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-8 text-center" data-id="element-287">
          Lo que puedes empezar a notar
        </h3>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-288">
          <div className="grid md:grid-cols-2" data-id="element-289">
            <div className="p-8 md:p-12 bg-[#C06B6B] text-white flex flex-col justify-center" data-id="element-290">
              <h4 className="text-xl font-serif font-bold mb-6" data-id="element-291">
                Desde la primera sesión:
              </h4>
              <ul className="space-y-3" data-id="element-292">
                {['Respiración más profunda sin esfuerzo', 'Mandíbula y pecho soltándose', 'Menos ruido mental', 'Sensación física de seguridad'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-293">
                    <Sparkles className="h-4 w-4 text-white/60 flex-shrink-0" data-id="element-294" />
                    <span data-id="element-295">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-296">
              <h4 className="text-xl font-serif font-bold text-gray-900 mb-6" data-id="element-297">
                Con práctica diaria:
              </h4>
              <div className="grid grid-cols-1 gap-3" data-id="element-298">
                {[{
                icon: Heart,
                text: 'Menos reactividad'
              }, {
                icon: Shield,
                text: 'Mejor descanso'
              }, {
                icon: Brain,
                text: 'Más estabilidad emocional'
              }, {
                icon: Eye,
                text: 'Más presencia'
              }].map((f, i) => <div key={i} className="flex items-center gap-3 p-3 bg-[#FAF5EF] rounded-lg" data-id="element-299">
                    <f.icon className="h-5 w-5 text-[#C06B6B] flex-shrink-0" data-id="element-300" />
                    <span className="text-gray-800 font-medium" data-id="element-301">{f.text}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}